module.exports = __webpack_public_path__ + "img/ea-logo-dark.549a3c1c.png";